import { EnvironmentProviders, inject, NgZone, provideAppInitializer } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import type { Instance } from 'tippy.js';

type RacineTippy = HTMLElement & { _tippy?: Instance };

/**
 * Masque les infobulles Tippy (`[tp]` au survol ou au focus) dès qu'une zone défile,
 * n'importe où dans l'application : sans cela, une infobulle restait accrochée à
 * une position qui ne correspondait plus à son élément.
 *
 * - Écoute en capture : l'évènement `scroll` ne remonte pas, il faut l'attraper
 *   sur le document pour voir celui des conteneurs internes (shell, modales, Deck).
 * - Les poppers au clic (menus, variation `popper`) restent ouverts, de même qu'un
 *   défilement à l'intérieur d'un Tippy : faire défiler un menu ne le ferme pas.
 * - Hors zone Angular : un défilement ne déclenche aucune détection de changements.
 *
 * Les `title` natifs sont gérés par le navigateur, hors de portée du code.
 */
export function provideTooltipsMasquesAuDefilement(): EnvironmentProviders {
    return provideAppInitializer(() => {
        const document = inject(DOCUMENT);
        inject(NgZone).runOutsideAngular(() => {
            document.addEventListener('scroll', event => {
                if (event.target instanceof Element && event.target.closest('[data-tippy-root]')) return;
                for (const racine of document.querySelectorAll<RacineTippy>('[data-tippy-root]')) {
                    const instance = racine._tippy;
                    if (instance?.state.isVisible && instance.props.trigger.includes('mouseenter')) {
                        instance.hide();
                    }
                }
            }, { capture: true, passive: true });
        });
    });
}
